<div>
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/cookingbook/servingp.svg" alt="" />

      <p *ngIf="type == 'edit'">افزودن سریع</p>
      <p *ngIf="type == 'search'">ویرایش</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <div class="add-food-bottomsheet-input-holder cooking-holder">
      <p class="cooking-unit-text">نام</p>
      <input
        type="text"
        [(ngModel)]="ListItemText"
        (input)="chekedInput($event)"
      />
    </div>
    <div
      class="button"
      (click)="save()"
      *ngIf="type == 'search'"
      [ngClass]="{ active: active }"
    >
      ثبت
    </div>
    <div class="button-edit" *ngIf="type == 'edit'">
      <div class="submit" (click)="update()" [ngClass]="{ active: active }">
        ثبت ویرایش
      </div>
      <div class="delete" (click)="delete()">حذف از لیست</div>
    </div>
  </div>
</div>
